import thunkMiddleware from 'redux-thunk';
import { createStore, applyMiddleware, compose } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage/session';
import * as Sentry from '@sentry/react';
import rootReducer, { RootState } from '../modules';
import AppConfig from '@config';
import {
  useSelector as uS,
  TypedUseSelectorHook,
  useDispatch as uD
} from 'react-redux';

const sentryReduxEnhancer = Sentry.createReduxEnhancer();

const persistConfig = {
  key: AppConfig.version ? AppConfig.version : 'dev',
  storage
};

const middlewares = [thunkMiddleware];

if (AppConfig.mode === 'development') {
  const { createLogger } = require(`redux-logger`);
  const logger = createLogger({
    collapsed: true
  });
  middlewares.push(logger);
}

const enhancedReducer = persistReducer(
  {
    ...persistConfig,
    blacklist: [
      'chat',
      'dashboard',
      'marginBottom',
      'profile',
      'documents',
      'review'
    ]
  },
  rootReducer
);

export default function configureStore() {
  const store = createStore(
    enhancedReducer,
    composeWithDevTools(
      compose(applyMiddleware(...middlewares), sentryReduxEnhancer)
    )
  );
  const persistor = persistStore(store);
  return { store, persistor };
}

export const { store, persistor } = configureStore();

export const useSelector: TypedUseSelectorHook<RootState> = uS;

export type AppDispatch = typeof store.dispatch;

export const useDispatch = () => uD<AppDispatch>();
